import type { ReactNode } from 'react';
import { Link } from '@/components/LocalizedLink';
import type { PortfolioProject } from '@/lib/portfolioProjects';

type ProjectCardLinkProps = {
  project: Pick<PortfolioProject, 'slug' | 'liveUrl'>;
  label: string;
  className?: string;
  children: ReactNode;
};

const ProjectCardLink = ({ project, label, className, children }: ProjectCardLinkProps) => {
  if (project.liveUrl) {
    return (
      <a
        href={project.liveUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className={className}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={`/projects/${project.slug}`} className={className}>
      {children}
    </Link>
  );
};

export default ProjectCardLink;
